import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "userLogin" }

import { reactive, ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserControllerService } from "../../../generated/services/UserControllerService";
import { UserAccountLoginRequest } from "../../../generated/models/UserAccountLoginRequest";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLoginView',
  setup(__props) {

document.title="登录"

const router = useRouter();

const route = useRoute();

const store = useStore();

const accountForm = reactive({
  userAccount: "",
  userPassword: "",
} as UserAccountLoginRequest);

const emailForm = reactive({
  email: undefined,
  captcha: "",
});

const isEmail = ref(false);

const handleAccountSubmit = async () => {
  // console.log(form);
  const res = await UserControllerService.userLoginUsingPost(accountForm);
  if (res.code === 0) {
    message.success("登录成功");
    // console.log(route.query.redirect);
    await store.dispatch("user/getLoginUser");
    // 将token保存在localStorage中
    localStorage.setItem("token", res.data.token);
    // 重定向到用户之前访问的页面
    await router.push({
      path: `${route.query.redirect ?? "/"}`,
      //不会占用浏览器历史记录的堆栈，不能在通过后退箭头返回登录页面
      replace: true,
    });
  } else {
    message.error("登录失败，" + res.message);
  }
};
const handleEmailSubmit = async () => {
  // console.log(form);
  const res = await UserControllerService.userEmailLoginUsingPost(emailForm);
  if (res.code === 0) {
    message.success("登录成功");
    // console.log(route.query.redirect);
    await store.dispatch("user/getLoginUser");
    // 将token保存在localStorage中
    localStorage.setItem("token", res.data.token);
    // 重定向到用户之前访问的页面
    await router.push({
      path: `${route.query.redirect ?? "/"}`,
      //不会占用浏览器历史记录的堆栈，不能在通过后退箭头返回登录页面
      replace: true,
    });
  } else {
    message.error("登录失败，" + res.message);
  }
};

const tip = ref("获取验证码");
const time = ref(0);
const intervalId = ref();
let emailRegex = new RegExp(
  "^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$"
);
const getCaptcha = async (email: string, op: string) => {
  time.value = 60; // 设置倒计时时间为60秒
  intervalId.value = setInterval(() => {
    if (time.value > 0) {
      time.value--; // 每秒减少1
    } else {
      clearInterval(intervalId.value); // 清除计时器
      time.value = 0; // 重置倒计时时间
    }
  }, 1000); // 设置定时器，每1000毫秒（1秒）执行一次
  const res = await UserControllerService.getCaptchaUsingGet(email, op);
  if (res.code == 0) {
    message.success("发送成功，请注意查收");
    console.log("hh");
  } else {
    message.error("发送失败，请稍后再试，" + res.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_IconEmail = _resolveComponent("IconEmail")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_icon_user = _resolveComponent("icon-user")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEmail.value)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          model: accountForm,
          onSubmit: handleAccountSubmit,
          "label-align": "left",
          "auto-label-width": "",
          style: {"max-width":"480px","margin":"0 auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              rules: [
          { required: true, message: '账号不能为空' },
          { minLength: 4, message: '账号长度不能低于4位' },
          { maxLength: 15, message: '账号长度不能高于15位' },
        ],
              field: "userAccount",
              label: "账号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  content: "大写字母、小写字母、数字",
                  position: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: accountForm.userAccount,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accountForm.userAccount) = $event)),
                      placeholder: "请输入账号"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              rules: [
          { required: true, message: '密码不能为空' },
          { minLength: 8, message: '密码长度不能低于8位' },
          { maxLength: 16, message: '密码长度不能高于16位' },
        ],
              field: "userPassword",
              label: "密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  content: "大写字母、小写字母、数字",
                  position: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      modelValue: accountForm.userPassword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((accountForm.userPassword) = $event)),
                      placeholder: "请输入密码"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  long: "",
                  style: {"background-color":"rgb(24, 25, 28)","border-radius":"6px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" 没有账号？ "),
                _createVNode(_component_a_link, { href: "/user/register" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 注册")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  content: "邮箱登录",
                  position: "bl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "dashed",
                      onClick: _cache[2] || (_cache[2] = ()=>{isEmail.value=!isEmail.value})
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconEmail, { style: {"height":"40px","width":"40px"} })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    (isEmail.value)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 1,
          model: emailForm,
          onSubmit: handleEmailSubmit,
          "label-align": "left",
          "auto-label-width": "",
          style: {"max-width":"480px","margin":"0 auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              rules: [{ required: true, message: '邮箱不能为空' }],
              field: "email",
              label: "邮箱"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: emailForm.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailForm.email) = $event)),
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_a_button, {
                  type: "text",
                  status: "success",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (getCaptcha(emailForm.email, 'LOGIN'))),
                  disabled: 
            emailForm.email == undefined || !_unref(emailRegex).test(emailForm.email) || time.value > 0
          ,
                  style: {"height":"32px","width":"130px"}
                }, {
                  default: _withCtx(() => [
                    (time.value != 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(time.value), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (time.value == 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(tip.value), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              rules: [{ required: true, message: '验证码不能为空' }],
              field: "captcha",
              label: "验证码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  content: "数字",
                  position: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      modelValue: emailForm.captcha,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((emailForm.captcha) = $event)),
                      placeholder: "请输入验证码"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  long: "",
                  style: {"background-color":"rgb(24, 25, 28)","border-radius":"6px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("登录 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createTextVNode(" 没有账号？ "),
                _createVNode(_component_a_link, { href: "/user/register" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 注册")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_tooltip, {
                  content: "账号登录",
                  position: "bl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "dashed",
                      onClick: _cache[6] || (_cache[6] = ()=>{isEmail.value=!isEmail.value}),
                      style: {"background-color":"rgb(248, 248, 248)","border":"none"}
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_icon_user, { style: {"height":"40px","width":"40px"} })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true)
  ]))
}
}

})